module.exports = __webpack_public_path__ + "img/Siparti-green-trees-512px.c4c03646.png";